// extracted by mini-css-extract-plugin
export default {"cls1":"BulkFollowListModal-cls1_Vgl","cls2":"BulkFollowListModal-cls2__5_ BulkFollowListModal-cls1_Vgl"};